import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-coral/25" data-id="element-0" data-mp="23vkzqt1dsvr1">
      <TopBar data-id="element-1" data-mp="3ikr002qv3a7b" />
      <main data-id="element-2" data-mp="3iiwg8rrbto4t">
        <HeroSection data-id="element-3" data-mp="3ijfvu1ti80fo" />
        <StatsBar data-id="element-4" data-mp="3ihv0wb3a2fha" />
        <TransformationSection data-id="element-5" data-mp="3mlj8uuvtnd32" />
        <PainPointsSection data-id="element-6" data-mp="3mkhlbqxmcy4g" />
        <KitContentsSection data-id="element-7" data-mp="3mjq1tehaqquj" />
        <InstantAccessSection data-id="element-8" data-mp="3rc9du70c5dx8" />
        <BonusesSection data-id="element-9" data-mp="3rbzo8kj7d8s2" />
        <PricingSection data-id="element-10" data-mp="3rcsyhvhdegey" />
        <GuaranteeSection data-id="element-11" data-mp="3recc1ebn6dd1" />
        <TestimonialsSection data-id="element-12" data-mp="5opiv1o0k3w" />
        <FAQSection data-id="element-13" data-mp="4n4bxqxqh8g" />
        <FinalCTASection data-id="element-14" data-mp="56n1goet9nj" />
      </main>
      <Footer data-id="element-15" data-mp="2zld0746gb58w" />
    </div>;
}